import { reqGET } from "../src/Utils";
import { getTokenInfo } from './UseToken';

import { api_list_route } from '../src/components/WEBContent/PerfisMenus/Config';

import SidebarData from "./components/Sidebar/SideBarData";

import Main from './components/Main/Init'

import Calendar_Event from './components/Calendar/Event/Init'
import Calendar_Category from './components/Calendar/Category/Init'

import Content from './components/WEBContent/Content/Init'
import Content_News from './components/WEBContent/News/Init'
import Content_Banner from './components/WEBContent/Banner/Init'
import Content_Gallery from './components/WEBContent/Gallery/Init'
import Content_Testemony from './components/WEBContent/Testemony/Init'
import Content_Category from './components/WEBContent/Category/Init'
import Content_Contest from './components/WEBContent/Contest/Init'

/*import Project from './components/Project/Content/Init'
import Project_Area from './components/Project/Area/Init'
import Project_Program from './components/Project/Program/Init'
import Project_Domain from './components/Project/Domain/Init'
import Project_Scope from './components/Project/Scope/Init'
import Project_Fund from './components/Project/Fund/Init'*/

import Store_Product from './components/Store/Product/Init'
import Store_Category from './components/Store/Category/Init'
import Store_Category_Value from './components/Store/Category/Value/Init'
import Store_Attribute from './components/Store/Attribute/Init'
import Store_Attribute_Value from './components/Store/Attribute/Value/Init'
import Store_Feature from './components/Store/Feature/Init'
import Store_Feature_Value from './components/Store/Feature/Value/Init'
import Store_Brand from './components/Store/Brand/Init'
import Store_Brand_Value from './components/Store/Brand/Value/Init'
import Store_Preferences from './components/Store/Shipping/Preferences/Init'
import Store_Shipping_Carrier from './components/Store/Shipping/Carrier/Init'
import Store_Shipping_Zone from './components/Store/Shipping/Zone/Init'
import Store_Shipping_Country from './components/Store/Shipping/Country/Init'
import Store_Taxe from './components/Store/Shipping/Taxe/Init'

import Estancia_Config from './components/Estancia/Config/Init'
import Estancia_Meios from './components/Estancia/Meios/Init'
import Estancia_Pista from './components/Estancia/Pista/Init'
import Estancia_Forfait from './components/Estancia/Forfait/Init'
import Estancia_Equipamento from './components/Estancia/Equipamento/Init'
import Estancia_Voucher from './components/Estancia/Voucher/Init'
import Estancia_Pack from './components/Estancia/Pack/Init'
import Estancia_Aula from './components/Estancia/Aula/Init'
import Estancia_AulaInfo from './components/Estancia/AulaInfo/Init'
import Estancia_Zona from './components/Estancia/Zona/Init'
import Estancia_Atividade from './components/Estancia/Atividade/Init'
import Estancia_PurchaseOrder from './components/Estancia/PurchaseOrder/Init'
import Estancia_PurchaseOrderPaied from './components/Estancia/PurchaseOrderPaied/Init'
import Estancia_PurchaseOrderUsed from './components/Estancia/PurchaseOrderUsed/Init'
import Estancia_PurchaseOrderNotUsed from './components/Estancia/PurchaseOrderNotUsed/Init'

import Perfil from './components/WEBContent/PerfisMenus/Init'
import Perfis_Menus from './components/WEBContent/PerfisMenus/Init'
import Structure from './components/WEBContent/Structure/Init'
import Utilizador from './components/Entities/Utilizador/Init'
import Instrutor from './components/Entities/Instrutor/Init'
import Colaborador from './components/Entities/Colaborador/Init'
import Cliente from './components/Entities/Cliente/Init'
import Company from './components/Entities/Company/Init'

export default function UseSidebar() {

  const getSidebar = async (profile, isEdit = false) => {

    let sidebar_init = SidebarData({
      rotas: {
        Main: Main,
        
        Calendar_Event: Calendar_Event,
        Calendar_Category: Calendar_Category,

        Content: Content,
        Content_News: Content_News,
        Content_Banner: Content_Banner,
        Content_Gallery: Content_Gallery,
        Content_Testemony: Content_Testemony,
        Content_Category: Content_Category,
        Content_Contest: Content_Contest,
        
        Store_Product: Store_Product,
        Store_Category: Store_Category,
        Store_Category_Value: Store_Category_Value,
        Store_Attribute: Store_Attribute,
        Store_Attribute_Value: Store_Attribute_Value,
        Store_Feature: Store_Feature,
        Store_Feature_Value: Store_Feature_Value,
        Store_Brand: Store_Brand,
        Store_Brand_Value: Store_Brand_Value,
        Store_Preferences: Store_Preferences,
        Store_Shipping_Carrier: Store_Shipping_Carrier, 
        Store_Shipping_Zone: Store_Shipping_Zone,
        Store_Shipping_Country: Store_Shipping_Country,
        Store_Taxe: Store_Taxe,

        Estancia_Config: Estancia_Config,
        Estancia_Meios: Estancia_Meios,
        Estancia_Pista: Estancia_Pista,
        Estancia_Forfait: Estancia_Forfait,
        Estancia_Equipamento: Estancia_Equipamento,
        Estancia_Voucher: Estancia_Voucher,
        Estancia_Pack: Estancia_Pack,
        Estancia_Aula: Estancia_Aula,
        Estancia_AulaInfo: Estancia_AulaInfo,
        Estancia_Zona: Estancia_Zona,
        Estancia_Atividade: Estancia_Atividade,
        Estancia_PurchaseOrder: Estancia_PurchaseOrder,
        Estancia_PurchaseOrderPaied: Estancia_PurchaseOrderPaied,
        Estancia_PurchaseOrderUsed: Estancia_PurchaseOrderUsed,
        Estancia_PurchaseOrderNotUsed: Estancia_PurchaseOrderNotUsed,

        /*Project: Project,
        Project_Area: Project_Area,
        Project_Program: Project_Program,
        Project_Domain: Project_Domain,
        Project_Scope: Project_Scope,
        Project_Fund: Project_Fund,*/
        
        Perfil: Perfil,
        Perfis_Menus: Perfis_Menus,
        Utilizador: Utilizador,
        Instrutor: Instrutor,
        Colaborador: Colaborador,
        Cliente: Cliente,
        Company: Company,
        Structure: Structure
      }
    })

    let companycodeLS = getTokenInfo().companycode
    //console.log(companycodeLS)

    if (companycodeLS === null || profile === null) {
      return sidebar_init
    }
    else {
     
      let result = await reqGET(api_list_route(companycodeLS))
        .then(res => {

          let profiles_list = res.data.filter(item => item.name === profile)
        
          let update_sidebar =(sidebar_original, sidebar_db) => {

            sidebar_original.forEach(element => {
  
                let tmp = sidebar_db.filter(e => e.id === element.id)

                if (tmp.length > 0){

                /*   element.title  =   element[0].title
                  element.path   =   element[0].path
                  element.icon   =   element[0].icon
                  element.icon_b =   element[0].icon_b
                  element.cName  =   element[0].cName */
                  element.allow  =   tmp[0].allow
                  element.create =   tmp[0].create
                  element.edit   =   tmp[0].edit
                  element.view   =   tmp[0].view
                  element.remove =   tmp[0].remove

                  update_sidebar( element.submenu, tmp[0].submenu)
                }

 
              })
              return sidebar_original
            }
         
          if (isEdit === true) {
           
            return update_sidebar( sidebar_init , profiles_list[0].permissions.menu )

          } else {
          
            return profiles_list.length > 0 ? profiles_list[0].permissions.menu : sidebar_init

          }

        })

      return result
    }
  }

  return {
    getSidebar,
  }
}